import { render } from "./SearchInput.vue?vue&type=template&id=0ed5f436&scoped=true"
import script from "./SearchInput.vue?vue&type=script&lang=js"
export * from "./SearchInput.vue?vue&type=script&lang=js"

import "./SearchInput.vue?vue&type=style&index=0&id=0ed5f436&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed5f436"]])

export default __exports__